import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredLocations,
  selectLocationFilterVisible,
  selectLocationLoading,
  selectfetchLocationLoading
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { showModal } from 'Core/redux/main/slice';
import { Edit, Trash2 } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { deleteLocation } from './store/slice';
import { actions as locationActions } from './store/slice';

const { setLocation } = locationActions;

const { LOCATION_ADD_EDIT } = MODAL_TYPES;

const LocationTile = props => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const locationTileRef = useRef(null);
  const filteredLocations = useSelector(selectFilteredLocations);
  const isLoading = useSelector(selectLocationLoading);
  const filterVisible = useSelector(selectLocationFilterVisible);
  const headerVisible = useSelector(isHeaderVisible);
  const isFetchDataLoading = useSelector(selectfetchLocationLoading);


  const updateColumnSettings = useCallback(() => {
    if (locationTileRef.current) {
      const width = locationTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  const itemData = filteredLocations.map(location => <Tile location={location} />);

  return (
    <div
      className={`shipment-tile-body ${filterVisible ? 'filter-visible' : ''} ${!headerVisible ? 'header-collapsed' : ''
        }`}
      ref={locationTileRef}
    >
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredLocations.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150} // Adjusted row height
        />
      }
    </div>
  );
};

const Tile = ({ location }) => {

  console.log('Location itemData', location);
  const dispatch = useDispatch();

  const handleEdit = e => {
    e.stopPropagation();
    dispatch(setLocation(location));
    dispatch(showModal(LOCATION_ADD_EDIT, location));
  };

  const handleDelete = e => {
    e.stopPropagation();
    //dispatch(deleteLocation(location.processId));
  };

  return (
    <div key={location.processId || Math.random()} className="shipment-tile ellipsis-tile">
      <div
        className={`card p-3 m-2 ${location.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions">
          <ButtonGroup size="sm">
            <Button variant="light" onClick={handleEdit}>
              <Edit size={16} />
            </Button>
            {/* <Button variant="light" onClick={handleDelete}>
              <Trash2 size={16} />
            </Button> */}
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h6 className="mb-0 truncate-2lines" title={location.description}>{location.description} </h6>
              <span className="text-muted fa-sm">{location.name || '--'}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default LocationTile;
